export const postMapper = {
  memberNumber: 360022693713,
  phone1: 10072253674007,
  phone2: 10072199358615,
  userStatus: 360025770354,
  clientCategory: 10898980892951,
  ticketChannel: 360023899093,
  ticketTabulation: 10815489721495,
  completeName: 360054855194,
  email: 360054347934,
  socialReason: 10816761509015,
  fantasyName: 10816826253975,
  address: 10838234563735,
  redeemablePoints: 10895116347159,
  qualifyingPoints: 10895118911767,
  reservationCode: 10899057188759,
  flightsCount: 10895155905175,
  CNPJ: 360056619793,
  relationshipWithGol: 10894727623447,
  travelAgent: 9999999999999999999999999, // TODO:
  subChannel: 1900006384265,
  CPF: 360055358033,
  mainActivity: 10900727687447,
  numberOfEmployees: 10900266631447,
  annualBudgetforTravel: 10900731766679,
  occupation: 10901613970071,
  HowYouMettheProgram: 10901586603671,
};

export const postMapperPRD = {
  ticketChannel: 360026022153,
  subChannel: 5174127033879,
  relationshipWithGol: 13134924790551,
  travelAgent: 9999999999999999999999999, // TODO:
  ticketTabulation: 13135104832279,
  memberNumber: 360022291173,
  socialReason: 13136318328215,
  fantasyName: 13136378293015,
  address: 13136381205911,
  completeName: 1500003625902,
  email: 1500000321982,
  phone1: 13136551304343,
  phone2: 13136621513879,
  redeemablePoints: 13136640746263,
  qualifyingPoints: 13136633176727,
  flightsCount: 13136799306007,
  clientCategory: 13136834764311,
  reservationCode: 11170675004951,
  CNPJ: 13139637411607,
  HowYouMettheProgram: 13140043850007,
  numberOfEmployees: 13139732194455,
  mainActivity: 13139853677335,
  annualBudgetforTravel: 13139877496343,
  CPF: 360056374533,
  occupation: 13140222757655,
  userStatus: 360025770354,
};
